<template>
  <div>
    <el-dialog
      ref="viewDialog"
      v-dialogDrag
      title="查看调研问卷参与人员信息"
      :visible.sync="dialogVisible"
      class="abow_dialog h600_dialog"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
    >
      <el-form
        ref="dialogViewForm"
        :model="dialogViewForm"
        class="add-edit-view-form"
        @submit.native.prevent
      >
        <div class="modal-box">
          <h3 class="modal-title">
            调研问卷参与人员信息
          </h3>
          <div class="modal-row-box">
            <el-row :gutter="10">
              <el-col :span="4">
                <el-form-item label="活动省区">
                  <el-input
                    v-model="dialogViewForm.provinceName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item label="活动日期">
                  <el-date-picker
                    v-model="dialogViewForm.activityDate"
                    type="date"
                    format="yyyy-MM-dd"
                    disabled
                    style="width: 100%;"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item label="问卷编号">
                  <el-input
                    v-model="dialogViewForm.questionnaireCode"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="问卷名称">
                  <el-input
                    v-model="dialogViewForm.questionnaireName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item label="成长值">
                  <el-input
                    v-model="dialogViewForm.growthValue"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item label="腾讯问卷用户ID">
                  <el-input
                    v-model="dialogViewForm.uid"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="昵称">
                  <el-input
                    v-model="dialogViewForm.nickname"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="答题结束时间">
                  <el-input
                    v-model="dialogViewForm.finishAnswerTime"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="市场">
                  <el-input
                    v-model="dialogViewForm.market"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item label="门店名称">
                  <el-input
                    v-model="dialogViewForm.storeName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="专卖证号">
                  <el-input
                    v-model="dialogViewForm.certificateNo"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="本香门店码绑定电话">
                  <el-input
                    v-model="dialogViewForm.bxPhone"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="门店档位">
                  <el-input
                    v-model="dialogViewForm.level"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item label="小程序用户门店名称">
                  <el-input
                    v-model="dialogViewForm.appStoreName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="小程序用户专卖证号">
                  <el-input
                    v-model="dialogViewForm.appCertificateNo"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="小程序用户手机号">
                  <el-input
                    v-model="dialogViewForm.appPhone"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="微信号">
                  <el-input
                    v-model="dialogViewForm.wxId"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item label="成长值发放结果">
                  <el-input
                    v-model="dialogViewForm.grantResultValue"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="成长值发放时间">
                  <el-input
                    v-model="dialogViewForm.grantGrowthValueTime"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="成长值未发放原因">
                  <el-input
                    v-model="dialogViewForm.noGrantReason"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="状态">
                  <el-input
                    v-model="dialogViewForm.statusValue"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="18">
                <el-form-item label="异常信息">
                  <el-input
                    v-model="dialogViewForm.exceptionTypesValue"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-form>

      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// dialog拖拽Mixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 调研问卷API
import { viewSurveyQuestionnaireDetailApi } from '@/api/v2/surveyQuestionnaireDetail'

export default {
  components: {},
  mixins: [dialogDragMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      dialogViewForm: {},
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        let _this = this;

        _this.dialogViewForm = {}

        _this.loadSurveyQuestionnaireData()

        _this.$nextTick(() => {
          _this.$refs.dialogViewForm.clearValidate()
        })
      }
    }
  },
  methods: {
    // 加载数据
    loadSurveyQuestionnaireData () {
      let _this = this;
      viewSurveyQuestionnaireDetailApi({ id: _this.dataId }).then((response) => {
        const { data } = response;
        _this.dialogViewForm = data;

      })
    },
    modalClose () {
      let _this = this;
      _this.$emit('update:dialogVisible', false)
    },
  }
}
</script>
<style lang="scss"  scoped>
</style>
